export function findIntersectionsBetweenArrays(arrays: string[][]): string[] {
  const sets: Set<string>[] = arrays.map((array) => new Set(array));
  return Array.from(findIntersectionsBetweenSets(sets));
}

export function findIntersectionsBetweenSets(sets: Set<string>[]): Set<string> {
  const sorted = sets.sort((first, second) => first.size - second.size);

  if (!sorted.length) {
    return new Set();
  }

  const result = sorted.reduce((item1, item2) => {
    const newSet = new Set<string>();

    item1.forEach((entry) => {
      if (item2.has(entry)) {
        newSet.add(entry);
      }
    });
    return newSet;
  });

  return result;
}
